import {
  Mitarbeiter_UpdateFeiertagskontoUebertragAusVorjahrMutation,
  Mitarbeiter_UpdateFeiertagskontoUebertragAusVorjahrMutationVariables,
} from '@/gql/graphql';
import { gql, TypedDocumentNode } from '@apollo/client';

export const UPDATE_FEIERTAGSKONTO_UEBERTRAG_AUS_VORJAHR: TypedDocumentNode<
  Mitarbeiter_UpdateFeiertagskontoUebertragAusVorjahrMutation,
  Mitarbeiter_UpdateFeiertagskontoUebertragAusVorjahrMutationVariables
> = gql`
  mutation mitarbeiter_updateFeiertagskontoUebertragAusVorjahr(
    $input: mitarbeiter_updateFeiertagskontoUebertragAusVorjahrInput!
  ) {
    mitarbeiter_updateFeiertagskontoUebertragAusVorjahrResult(input: $input) {
      failure {
        message
        type
      }
      success {
        jahr
        uebertragAusVorjahr
      }
    }
  }
`;
